import { Component, OnInit } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { CameraServerService } from '../camera-server.service';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ANALYTIC_NAME, AppConstants, CAPTURE_RESOLUTIONS, FORMAT, MOTION_DETUCTION_SENSITIVITY_DETECTALL, MOTION_DETUCTION_SENSITIVITY_FILTERNOISE, MOTION_DETUCTION__METHODS, TYPE, hasPrivilege, ErrorMessageFormField, CAMERA_OWNED_LIST, LPR_CAMERA_LIST } from 'src/app/shared/app-constants';
import { MatDialog } from '@angular/material/dialog';
import { SiteCamLiveViewsComponent } from '../dialogs/site-cam-live-views/site-cam-live-views.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogueComponent } from 'src/app/components/confirmation-dialogue/confirmation-dialogue.component';
import { ConfigService } from 'src/app/services/config.service';
import { RtspUrlPlayerComponent } from '../dialogs/rtsp-url-player/rtsp-url-player.component';
@Component({
  selector: 'app-add-edit-camera-list',
  templateUrl: './add-edit-camera-list.component.html',
  styleUrls: ['./add-edit-camera-list.component.scss'],
  standalone: false
})
export class AddEditCameraListComponent implements OnInit {

  selectedTabCamera: number = 0;
  captureResolution: any = CAPTURE_RESOLUTIONS;
  format_data: any = FORMAT;
  type_data: any = TYPE;
  win_size_view: any = [];
  motion_detection_methods: any = MOTION_DETUCTION__METHODS;
  motion_detection_sensitivity: any = [];
  analytic_name: any = ANALYTIC_NAME;
  cameraInputForm: FormGroup = new FormGroup({});
  desired_rowHeight = '85vh';
  potentialId: any;
  loading: boolean = false;
  camUniqueId: string = '';
  dayImageUrl: string = '';
  nightImageUrl: string = '';
  description: string = '';
  selectedDayFiles: any;
  selectedNightFiles: any;
  isDayUpload: boolean = false;
  isNightUpload: boolean = false;
  dayType: string = '';
  nightType: string = '';
  editableCameraData: any = {}

  isFieldEnableDisable: boolean;
  editCameraFromSiteList: boolean = false;
  isHideCameraUniqueIdField: boolean = false;
  isSitePage: boolean = false;
  sitePId: any
  isvalidToAdd: boolean = false;
  copyBasePathUrls: string = "";
  hasEditPrivilege: boolean = false;
  hidePassword: boolean = true;
  errorMessageFormField: any = ErrorMessageFormField
  whitelistedSite: boolean = false;
  whitelistedIpList: any[] = [];
  siteInfo: any = {};
  cameraOwnedList: any[] = CAMERA_OWNED_LIST;
  lpr_camera_list: any[] = LPR_CAMERA_LIST;
  isCameraSettingFeature: boolean = false;


  constructor(
    public spinner: SpinnerService,
    private cameraService: CameraServerService,
    private toastr: ToastrService,
    private _location: Location,
    private router: Router,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private ngbModalService: NgbModal,
    public configService: ConfigService,
  ) { }

  noWhitespace(control: AbstractControl): ValidationErrors | null {
    if ((control.value as string).indexOf(' ') >= 0) {
      return { whitespace: true }
    }
    return null;
  }

  ngOnInit(): void {
    this.isCameraSettingFeature = this.configService.isFeatureEnabled('isCameraSetting');
    this.siteInfo = JSON.parse(sessionStorage.getItem('siteData'))
    this.selectedTabCamera = 0;
    this.cameraInputForm = this.formBuilder.group({
      camUniqueId: [''],
      cameraId: [''],
      camAnalyticName: ['', [Validators.required]],
      camName: ['', [Validators.required]],
      camChannelNo: ["-1", [Validators.required]],
      camType: ['AXIS', [Validators.required]],
      camIpUrl: ['', [Validators.required]],
      username: ['root', [Validators.required]],
      password: ['', [Validators.required]],
      supportPTZ: [false],
      comPortNo: [1, [Validators.required]],
      address: ['Pro-Vigil'],
      format: ['H264', [Validators.required]],
      feedDelay: ['20', [Validators.required]],
      emailId: [''],
      active: [true],
      methods: ['FILTER_NOISE', [Validators.required]],
      sensitivity: ['LEVEL_4', [Validators.required]],
      capture: ['R_320_BY_240', [Validators.required]],
      windowSizeView: ['R_320_BY_240', [Validators.required]],
      compression: ['MEDIUM', [Validators.required]],
      macAddress: ['', [Validators.required]],
      noMotionsFrames: ["1", [Validators.required]],
      noMotionSeconds: ["5", [Validators.required]],
      motionsFrames: ["1", [Validators.required]],
      motionSeconds: ["1", [Validators.required]],
      hdUrl: ['', [Validators.required, this.noWhitespaceValidator]],
      sdUrl: ['', [Validators.required, this.noWhitespaceValidator]],
      monitoringType: ['true', [Validators.required]],
      cameraOwnedBy: [""],
      lprCamera: ["false"],
    })
    const addCameraFlag = sessionStorage.getItem("isAddCameraInSite");
    const isEditfromSite = sessionStorage.getItem("isEditfromSite");
    const isCameraEdit = sessionStorage.getItem("isCameraEdit");
    this.potentialId = sessionStorage.getItem("potentialId") || '';
    if (isCameraEdit === "true") {
      this.isSitePage = false;
    } else {
      this.isSitePage = true;
    }
    if (addCameraFlag === "true") {
      this.isFieldEnableDisable = false;
      this.isHideCameraUniqueIdField = false;
      this.sitePId = sessionStorage.getItem("potentialId");
    } else {
      this.isFieldEnableDisable = true;
      this.isHideCameraUniqueIdField = true;
      // this.sitePId = newSiteData?.vtigerPotentialId;
    }
    if (isEditfromSite === "true") {
      this.editCameraFromSiteList = true;
      this.isHideCameraUniqueIdField = true;
      this.sitePId = sessionStorage.getItem("potentialId");
    } else {
      this.editCameraFromSiteList = false;
    }

    /** Checking the navigated URL Path with selected the CameraUniqueId which is getting from session  */
    const normalizeString = (str: string) => {
      return decodeURIComponent(str).replace(/\s+/g, '').toLowerCase();
    }
    const pathname = window.location.pathname;
    const camUniqueId = sessionStorage.getItem("camUniqueId");
    const normalizedPathname = normalizeString(pathname);
    const normalizedCamUniqueId = normalizeString(camUniqueId);
    if (normalizedPathname.includes(normalizedCamUniqueId)) {
      this.getCameraByCameraUniqueId();
    }
 
    if (this.cameraInputForm.value.methods === "FILTER_NOISE") {
      this.motion_detection_sensitivity = MOTION_DETUCTION_SENSITIVITY_FILTERNOISE;
      this.cameraInputForm.value.sensitivity = "LEVEL_4"
    }
    if (this.cameraInputForm.value.capture === 'R_480_BY_270') {
      let newSelectedSize = this.captureResolution?.filter((item: any) => item.value === "R_480_BY_270");
      this.win_size_view = newSelectedSize?.[0]?.windowSize;
      this.cameraInputForm.value.windowSizeView = "R_480_BY_270"
    }
    if (hasPrivilege('edit camera configuration')) {
      this.hasEditPrivilege = true;
    }
    if (this.cameraInputForm.value.camType === "AXIS") {
      this.cameraInputForm.controls['username']?.setValue('root');
      this.cameraInputForm.controls['password']?.setValue('60056005');
      let newSelectedSize = this.captureResolution?.filter((item: any) => item.value === "R_480_BY_270");
      this.win_size_view = newSelectedSize?.[0]?.windowSize;
      this.cameraInputForm.controls['capture']?.setValue('R_480_BY_270');
      this.cameraInputForm.controls['windowSizeView']?.setValue('R_480_BY_270');

    } else if (this.cameraInputForm.value.camType === "RTSP_OVER_HTTP" || this.cameraInputForm.value.camType === "RTSP_OVER_TCP") {
      this.cameraInputForm.controls['username']?.setValue('admin');
      this.cameraInputForm.controls['password']?.setValue('247Supp0rt!');
      let newSelectedSize = this.captureResolution?.filter((item: any) => item.value === "R_320_BY_240");
      this.win_size_view = newSelectedSize?.[0]?.windowSize;
      this.cameraInputForm.controls['capture']?.setValue('R_320_BY_240');
      this.cameraInputForm.controls['windowSizeView']?.setValue('R_320_BY_240');
    } else {
      this.cameraInputForm.controls['username']?.setValue('root');
      this.cameraInputForm.controls['password']?.setValue('');
      let newSelectedSize = this.captureResolution?.filter((item: any) => item.value === "R_480_BY_270");
      this.win_size_view = newSelectedSize?.[0]?.windowSize;
      this.cameraInputForm.controls['capture']?.setValue('R_480_BY_270');
      this.cameraInputForm.controls['windowSizeView']?.setValue('R_480_BY_270');
    }
  }

  get formControls() {
    return this.cameraInputForm.controls;
  }

  /**white space checks in hd url and sd url */
  noWhitespaceValidator(control: any) {
    const isSpace = (control.value || '').match(/\s/g);
    return isSpace ? { 'whitespace': true } : null;
  }

  selectFileDayFile(event: any) {
    this.selectedDayFiles = event.target.files;
    this.isNightUpload = false;
    this.isDayUpload = true;
    this.dayType = "DAY_IMAGE";
    if (event.target.files) {
      this.uploadDayNightImageFile();
    }
  }

  selectFileNightFile(event: any) {
    this.selectedNightFiles = event.target.files;
    this.isDayUpload = false;
    this.isNightUpload = true;
    this.nightType = "NIGHT_IMAGE"
    if (event.target.files) {
      this.uploadDayNightImageFile();
    }
  }

  /**Function call when changing the Tabs */
  changeTab(event: any) {
    this.selectedTabCamera = event;
    localStorage.setItem("selectedTabCamera", event);
  }

  /**Function call when selection the type*/
  handleSelectType(event: any) {
    if (event === 'AXIS') {
      this.cameraInputForm.controls['username']?.setValue('root');
      this.cameraInputForm.controls['password']?.setValue('60056005');
      this.handleSelectCapture('R_480_BY_270');
      let newSelectedSize = this.captureResolution?.filter((item: any) => item.value === "R_480_BY_270");
      this.win_size_view = newSelectedSize?.[0]?.windowSize;
      this.cameraInputForm.controls['capture']?.setValue('R_480_BY_270');
      this.cameraInputForm.controls['windowSizeView']?.setValue('R_480_BY_270');

    } else if (event === "RTSP_OVER_HTTP" || event === "RTSP_OVER_TCP") {
      this.cameraInputForm.controls['username']?.setValue('admin');
      this.cameraInputForm.controls['password']?.setValue('247Supp0rt!');
      this.handleSelectCapture('R_320_BY_240');
      let newSelectedSize = this.captureResolution?.filter((item: any) => item.value === "R_320_BY_240");
      this.win_size_view = newSelectedSize?.[0]?.windowSize;
      this.cameraInputForm.controls['capture']?.setValue('R_320_BY_240');
      this.cameraInputForm.controls['windowSizeView']?.setValue('R_320_BY_240');
    } else {
      this.cameraInputForm.controls['username']?.setValue('root');
      this.cameraInputForm.controls['password']?.setValue('');
      this.handleSelectCapture('R_480_BY_270');
      let newSelectedSize = this.captureResolution?.filter((item: any) => item.value === "R_480_BY_270");
      this.win_size_view = newSelectedSize?.[0]?.windowSize;
      this.cameraInputForm.controls['capture']?.setValue('R_480_BY_270');
      this.cameraInputForm.controls['windowSizeView']?.setValue('R_480_BY_270');
    }
  }

  /**Function call when selection the resolution*/
  handleSelectCapture(event: any) {
    let newSelectedSize = this.captureResolution?.filter((item: any) => item.value === event);
    this.win_size_view = newSelectedSize?.[0]?.windowSize;
    this.handleSelectWindowSize(event)
  }

  /**Function call when selection the resolution*/
  handleSelectWindowSize(event: any) {
    this.win_size_view.filter((item: any) => {
      if (item.value === event) {
        this.cameraInputForm.value.windowSizeView = item.value
      }
    })
  }

  /**Function call when selecting the motion detection methods */
  handleSelectMotionDetectionMethod(event: any) {
    if (event.value === "DETECT_ALL") {
      this.motion_detection_sensitivity = MOTION_DETUCTION_SENSITIVITY_DETECTALL;
      this.cameraInputForm.value.sensitivity = "MEDIUM"
    } else if (event.value === "SOM") {
      this.motion_detection_sensitivity = MOTION_DETUCTION_SENSITIVITY_FILTERNOISE;
      this.cameraInputForm.value.sensitivity = "LEVEL_1"
    } else if (event.value === "VU_METER") {
      this.motion_detection_sensitivity = MOTION_DETUCTION_SENSITIVITY_FILTERNOISE;
      this.cameraInputForm.value.sensitivity = "LEVEL_1"
    } else if (event.value === "FILTER_NOISE") {
      this.motion_detection_sensitivity = MOTION_DETUCTION_SENSITIVITY_FILTERNOISE;
      this.cameraInputForm.value.sensitivity = "LEVEL_4"
    }
  }

  /** This methods is used for upload day and night image */
  uploadDayNightImageFile() {
    const fileData: FormData = new FormData();
    if (this.isDayUpload) {
      fileData.append("file", this.selectedDayFiles[0]);
    }
    if (this.isNightUpload) {
      fileData.append("file", this.selectedNightFiles[0]);
    }
    const payload = {
      "potentialId": sessionStorage.getItem("potentialId"),
      "camUniqueId": this.camUniqueId,
      "file": fileData,
      "type": this.isDayUpload ? this.dayType : this.nightType
    }
    this.spinner.activate();
    this.loading = true;
    this.cameraService.uploadDayNightImg(payload).subscribe((response: any) => {
      if (response && response.success) {
        this.loading = false;
        this.spinner.deactivate();
        if (this.isDayUpload) {
          this.dayImageUrl = response?.data?.s3
          this.isNightUpload = false;
          this.selectedDayFiles = null;
        }
        if (this.isNightUpload) {
          this.nightImageUrl = response?.data?.s3;
          this.isDayUpload = false;
          this.selectedNightFiles = null;
        }
        this.toastr.success("File uploaded successfully")
      } else {
        this.loading = false;
        this.spinner.deactivate();
        this.toastr.error(AppConstants.defaultErrorMessage)
      }
    }, (err) => {
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
      }
    })
  }

  /** Get Camera based on the camera unique id*/
  getCameraByCameraUniqueId() {
    const cam_unique_id = sessionStorage.getItem("camUniqueId");
    this.spinner.activate();
    this.loading = true;
    this.cameraService.getCam(cam_unique_id).subscribe((response: any) => {
      if (response) {
        this.editableCameraData = response?.data?.camData;
        const responseCameraData = response?.data?.camData;
        this.loading = false;
        this.spinner.deactivate();
        // this.cameraId = responseCameraData.cameraId;
        sessionStorage.setItem("potentialId", response?.data?.potentialId);
        this.camUniqueId = responseCameraData.camUniqueId;

        let newSelectedWindowSize = this.captureResolution?.filter((item: any) => item.value === responseCameraData.windowSizeView);
        this.win_size_view = newSelectedWindowSize?.[0]?.windowSize;

        if (responseCameraData.mdMethod === "DETECT_ALL") {
          this.motion_detection_sensitivity = MOTION_DETUCTION_SENSITIVITY_DETECTALL;
        }
        this.copyBasePathUrls = responseCameraData.basePathUrl;
        this.cameraInputForm = this.formBuilder.group({
          // camUniqueId: responseCameraData.camUniqueId,
          // cameraId: responseCameraData.cameraId,
          // camAnalyticName: responseCameraData.analyticName,
          // camName: responseCameraData.cameraName,
          // camChannelNo: responseCameraData.channelNo,
          // camType: responseCameraData.cameraType,
          // camIpUrl: responseCameraData.url,
          // username: responseCameraData.username,
          // password: responseCameraData.password,
          // supportPTZ: `${responseCameraData.isPTZ}`,
          // comPortNo: responseCameraData.cameraPortNo,
          // address: responseCameraData.address,
          // format: responseCameraData.encoder,
          // feedDelay: responseCameraData.feedDelay,
          // emailId: responseCameraData.email,
          // active: responseCameraData.active,
          // methods: responseCameraData.mdMethod,
          // sensitivity: responseCameraData.mdSensitivity,
          // capture: responseCameraData.imageResolution,
          // windowSizeView: responseCameraData.windowSizeView,
          // compression: responseCameraData.compression,
          // macAddress: responseCameraData.macAddress,
          // noMotionsFrames: `${responseCameraData.noMotionFrames}`,
          // noMotionSeconds: `${responseCameraData.noMotionSeconds}`,
          // motionsFrames: `${responseCameraData.motionFrames}`,
          // motionSeconds: `${responseCameraData.motionSeconds}`,
          // hdUrl: responseCameraData.hdUrl,
          // sdUrl: responseCameraData.sdUrl,
          // monitoringType: `${responseCameraData.monitoringType}`
          camUniqueId: [responseCameraData.camUniqueId],
          cameraId: [responseCameraData.cameraId],
          camAnalyticName: [responseCameraData.analyticName, [Validators.required]],
          camName: [responseCameraData.cameraName, [Validators.required]],
          camChannelNo: [responseCameraData.channelNo, [Validators.required]],
          camType: [responseCameraData.cameraType, [Validators.required]],
          camIpUrl: [responseCameraData.url, [Validators.required]],
          username: [responseCameraData.username, [Validators.required]],
          password: [responseCameraData.password, [Validators.required]],
          supportPTZ: [`${responseCameraData.isPTZ}`],
          comPortNo: [responseCameraData.cameraPortNo, [Validators.required]],
          address: [responseCameraData.address],
          format: [responseCameraData.encoder, [Validators.required]],
          feedDelay: [responseCameraData.feedDelay, [Validators.required]],
          emailId: [responseCameraData.email],
          active: [responseCameraData.active],
          methods: [responseCameraData.mdMethod, [Validators.required]],
          sensitivity: [responseCameraData.mdSensitivity, [Validators.required]],
          capture: [responseCameraData.imageResolution, [Validators.required]],
          windowSizeView: [responseCameraData.windowSizeView, [Validators.required]],
          compression: [responseCameraData.compression, [Validators.required]],
          macAddress: [responseCameraData.macAddress, [Validators.required]],
          noMotionsFrames: [`${responseCameraData.noMotionFrames}`, [Validators.required]],
          noMotionSeconds: [`${responseCameraData.noMotionSeconds}`, [Validators.required]],
          motionsFrames: [`${responseCameraData.motionFrames}`, [Validators.required]],
          motionSeconds: [`${responseCameraData.motionSeconds}`, [Validators.required]],
          hdUrl: [responseCameraData.hdUrl, [Validators.required, this.noWhitespaceValidator]],
          sdUrl: [responseCameraData.sdUrl, [Validators.required, this.noWhitespaceValidator]],
          monitoringType: [`${responseCameraData.monitoringType}`, [Validators.required]],
          cameraOwnedBy: [responseCameraData.cameraOwnedBy === null ? "" : responseCameraData.cameraOwnedBy],
          lprCamera: [`${responseCameraData.lpr}`],
        })

        this.dayImageUrl = responseCameraData.dayImage;
        this.nightImageUrl = responseCameraData.nightImage;
        this.description = responseCameraData.description;
      } else {
        this.loading = false;
        this.spinner.deactivate();
        this.toastr.error(AppConstants.defaultErrorMessage)
      }
    }, (err) => {
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
      }
    })
  }

  cancelOrBack() {
    this._location.back()
  }

  // isMendatoryField() {
  //   if (this.cameraId !== '' && this.camAnalyticName !== '' && this.camName !== '' && this.camType !== '' &&
  //     this.username !== '' && this.password !== '' && this.camIpUrl !== '' && this.camChannelNo && this.supportPTZ !== '' &&
  //     this.supportPTZ !== '' && this.address !== '' && this.comPortNo && this.emailId !== '' && this.methods !== '' &&
  //     this.sensitivity !== '' && this.windowSizeView !== '' && this.capture !== '' && this.compression !== '' && this.macAddress !== '' &&
  //     this.sdUrl !== '' && this.hdUrl !== '' && this.monitoringType !== '' && this.noMotionsFrames && this.noMotionSeconds &&
  //     this.motionsFrames && this.motionSeconds) {
  //     // this.isvalidToAdd = true;
  //     return true;
  //   } else {
  //     // this.isvalidToAdd = false;
  //     return false;
  //   }
  // }

  /** Function for Add camera*/
  addCamera() {
    const siteData: any = JSON.parse(sessionStorage.getItem("siteData"));
    const requestPayload = {
      potentialId: JSON.parse(siteData?.vtigerPotentialId || ""),
      camData: {
        analyticName: this.cameraInputForm.value.camAnalyticName,
        cameraId: this.cameraInputForm.value.cameraId,
        cameraName: this.cameraInputForm.value.camName,
        cameraType: this.cameraInputForm.value.camType,
        username: this.cameraInputForm.value.username,
        password: this.cameraInputForm.value.password,
        description: this.description,
        url: this.cameraInputForm.value.camIpUrl,
        channelNo: parseInt(this.cameraInputForm.value.camChannelNo),
        isPTZ: this.cameraInputForm.value.supportPTZ,
        address: this.cameraInputForm.value.address,
        feedDelay: this.cameraInputForm.value.feedDelay,
        active: this.cameraInputForm.value.active,
        cameraPortNo: parseInt(this.cameraInputForm.value.comPortNo),
        encoder: this.cameraInputForm.value.format,
        email: this.cameraInputForm.value.emailId,
        mdMethod: this.cameraInputForm.value.methods,
        mdSensitivity: this.cameraInputForm.value.sensitivity,
        windowSizeView: this.cameraInputForm.value.windowSizeView,
        imageResolution: this.cameraInputForm.value.capture,
        streamResolution: "R_960_BY_272",
        compression: this.cameraInputForm.value.compression,
        macAddress: this.cameraInputForm.value.macAddress,
        dayImage: this.dayImageUrl,
        nightImage: this.nightImageUrl,
        sdUrl: this.cameraInputForm.value.sdUrl,
        hdUrl: this.cameraInputForm.value.hdUrl,
        monitoringType: /^true$/i.test(this.cameraInputForm.value.monitoringType),
        noMotionFrames: parseInt(this.cameraInputForm.value.noMotionsFrames),
        noMotionSeconds: parseInt(this.cameraInputForm.value.noMotionSeconds),
        motionFrames: parseInt(this.cameraInputForm.value.motionsFrames),
        motionSeconds: parseInt(this.cameraInputForm.value.motionSeconds),
        cameraOwnedBy: this.cameraInputForm.value.cameraOwnedBy,
        lpr: this.cameraInputForm.value.lprCamera
      }
    }
    if (this.cameraInputForm.invalid) {
      return;
    } else {
      if (!this.cameraInputForm.get('hdUrl').hasError('whitespace')) {
        this.spinner.activate();
        this.loading = true;
        this.cameraService.addCam(requestPayload).subscribe((response) => {
          if (response && response.success) {
            this.loading = false;
            this.spinner.deactivate();
            this.toastr.success("Camera added successfully");
            sessionStorage.setItem("camUniqueId", response?.data?.camUniqueId);
            this.router.navigate([`/camera-server/sitelist/${JSON.parse(siteData?.vtigerPotentialId || "")}`])
          } else {
            this.loading = false;
            this.spinner.deactivate();
            this.toastr.error(response?.messages !== null ? response?.messages[0] : AppConstants.defaultErrorMessage)
          }
        }, (err) => {
          this.spinner.deactivate();
          if (err && err.error && err.error.message && err.error.message.length > 0) {
            this.toastr.error(err.error.message, 'Error');
          } else {
            this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
          }
        })
      } else {
        return;
      }
    }
  }

  /** Function for Update Camera*/
  updateCamera() {
    const siteData: any = JSON.parse(sessionStorage.getItem("siteData"));
    const requestPayload = {
      potentialId: JSON.parse(siteData?.vtigerPotentialId || ""),
      camData: {
        ...this.editableCameraData,
        cameraName: this.cameraInputForm.value.camName,
        analyticName: this.cameraInputForm.value.camAnalyticName,
        url: this.cameraInputForm.value.camIpUrl,
        cameraId: this.cameraInputForm.value.cameraId,
        cameraType: this.cameraInputForm.value.camType,
        username: this.cameraInputForm.value.username,
        password: this.cameraInputForm.value.password,
        description: this.description,
        channelNo: parseInt(this.cameraInputForm.value.camChannelNo),
        isPTZ: this.cameraInputForm.value.supportPTZ,
        feedDelay: this.cameraInputForm.value.feedDelay,
        encoder: this.cameraInputForm.value.format,
        active: this.cameraInputForm.value.active,
        cameraPortNo: parseInt(this.cameraInputForm.value.comPortNo),
        email: this.cameraInputForm.value.emailId,
        mdMethod: this.cameraInputForm.value.methods,
        mdSensitivity: this.cameraInputForm.value.sensitivity,
        windowSizeView: this.cameraInputForm.value.windowSizeView,
        imageResolution: this.cameraInputForm.value.capture,
        compression: this.cameraInputForm.value.compression,
        macAddress: this.cameraInputForm.value.macAddress,
        dayImage: this.dayImageUrl,
        nightImage: this.nightImageUrl,
        sdUrl: this.cameraInputForm.value.sdUrl,
        hdUrl: this.cameraInputForm.value.hdUrl,
        monitoringType: /^true$/i.test(this.cameraInputForm.value.monitoringType),
        noMotionFrames: parseInt(this.cameraInputForm.value.noMotionsFrames),
        noMotionSeconds: parseInt(this.cameraInputForm.value.noMotionSeconds),
        motionFrames: parseInt(this.cameraInputForm.value.motionsFrames),
        motionSeconds: parseInt(this.cameraInputForm.value.motionSeconds),
        cameraOwnedBy: this.cameraInputForm.value.cameraOwnedBy,
        lpr: this.cameraInputForm.value.lprCamera
      }
    }
    this.spinner.activate();
    this.loading = true;
    this.cameraService.updateCam(requestPayload).subscribe((response: any) => {
      if (response && response?.success) {
        this.loading = false;
        this.spinner.deactivate();
        this.toastr.success("Camera updated successfully");
        sessionStorage.setItem("camUniqueId", response?.data?.camUniqueId);
        this.router.navigate([`/camera-server/sitelist/${JSON.parse(siteData?.vtigerPotentialId || "")}`])
      } else {
        this.toastr.error(response?.messages[0] || AppConstants.defaultErrorMessage)
        this.loading = false;
        this.spinner.deactivate();
      }
    }, (err) => {
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
      }
    })
  }

  /** Function for copy base path url in camera*/
  handleCopyBasePathUrl() {
    const unsecuredCopyToClipboard = (text: any) => {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy')
      } catch (err) {
        console.error('Unable to copy to clipboard', err);
        this.toastr.error("Please try again !");
      }
      document.body.removeChild(textArea)
    };
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(this.copyBasePathUrls);
    } else {
      unsecuredCopyToClipboard(this.copyBasePathUrls);
    }
    this.toastr.success("Camera base path url copied!");
  }

  /** Show the live view for single Camera */
  liveViewForSingleCamera(event: any) {
    const dialogRef = this.dialog.open(SiteCamLiveViewsComponent, {
      data: { vtigerPotentialId: this.potentialId, isSingleCam: [this.editableCameraData], siteAccess: this.siteInfo?.siteAccess },
      disableClose: true,
      width: '50%',
      height: '85%',
      panelClass: 'full-screen-modal'
    });
  }

  /** Function call when user check the white listed option */
  handleCheckWhitelisted(event: any) {
    this.whitelistedSite = event.checked
  }

  /** Function call for individual camera sync */
  ManualSyncCamera() {
    if (this.editableCameraData?.connected) {
      let popupData = {
        title: "Confirmation?",
        message: `Are you sure you want sync Day Night view for camera - ${this.cameraInputForm?.value?.camName}`,
        cancelBtnText: "No",
        confirmBtnText: "Yes"
      }
      let dialog = this.ngbModalService.open(ConfirmationDialogueComponent);
      dialog.componentInstance._data = popupData;
      dialog.result.then(data => {
        if (data) {
          this.spinner.activate();
          const requestParam: any = {
            potentialId: this.potentialId,
            camUnqId: sessionStorage.getItem("camUniqueId"),
            type: 'live'
          }
          this.cameraService.syncDayNightImageIndividualCam(requestParam).subscribe((response: any) => {
            if (response && response.success) {
              this.spinner.deactivate();
              this.toastr.success(response.data || "Successfully synced the Day Night views");
              this.getCameraByCameraUniqueId();
            } else {
              this.spinner.deactivate();
              this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
            }
          }, (err) => {
            this.spinner.deactivate();
            if (err && err.error && err.error.message && err.error.message.length > 0) {
              this.toastr.error(err.error.message, 'Error');
            } else {
              this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
            }
          })
        }
      })
    } else {
      this.toastr.error(`Camera - ${this.cameraInputForm?.value?.camName} is offline, Please try after some time.`, 'Error');
    }

  }

  RTSPHDUrlCheck(){
    const dialogRef = this.dialog.open(RtspUrlPlayerComponent, {
      data: {streamUrl: this.cameraInputForm.value.hdUrl} ,
      disableClose: true,
      width: '50%',
      panelClass: 'full-screen-modal'
    });
  }

  RTSPSDUrlCheck(){
    const dialogRef = this.dialog.open(RtspUrlPlayerComponent, {
      data:  {streamUrl: this.cameraInputForm.value.sdUrl} ,
      disableClose: true,
      width: '50%',
      panelClass: 'full-screen-modal'
    });
  }
}
